module.exports = __webpack_public_path__ + "static/media/icon-supplies-slippers.03f53e97.svg";